const en = {
  menu: {
    about: { title: "About Us" },
    products: {
      title: "Products",
      tea: "Tea",
      coffee: "Coffee",
      agricultural: "Agricultural",
      energyDrink: "Energy Drink",
      juice: "Guava Juice",
      oil: "Cooking Oil",
    },
    promotion: { title: "Promotions" },
    news: {
      title: "News",
      newsTea: "Tea news",
      newsCoffee: "Coffee news",
      newsAgri: "Agricultural news",
    },
    noidia: { title: "Domestic" },
    xuatkhau: { title: "Export" },
    recruitment: { title: "Jobs" },
    muahang: { title: "Purchase" },
    contact: { title: "Contact" },
    search: { title: "Search" },
    profile: { title: "Profile" },
    language: { title: "Language" },
  },
  footer: {
    addressLabel: "Address",
    customerPolicy: "CUSTOMER POLICY",
    contactInfo: "Contact Info",
    factory: "FACTORY ADDRESS",
    followUs: "FOLLOW US",
    contactWith: "CONNECT WITH VIET THIEN",
    payments: "Payment methods",
    cod: "COD",
    bankTransfer: "Bank transfer",
    wallet: "Electronic wallet",
    info1:
      "Business Certificate Number: 0305693542 – Issued on Febuary 22, 2008",
    info2: "By the Department of Planning and Investment of HCM City.",
  },
  contact: {
    content:
      "If you have any concern or wish to cooperate, please leave your information, we will assist you as soon as possible.",
    taxCodeLabel: "Tax code",
    email: "Email",
    address: "Office",
    form: {
      title: "Contact us",
      fullName: "Name",
      email: "Email",
      phone: "Phone number",
      address: "Address",
      content: "Comments",
      button: "Submit",
      loading: "Sending...",
    },
    placeholder: {
      fullName: "Your name",
      email: "Your email address",
      phone: "Your phone number",
      content: "Enter a comment here...",
      address: "Your address",
    },
    toast: {
      success: "Your information has been sent successfully.",
      error: "Failed to send information. Please try again later.",
    },
    map: {
      title: "List of Viet Thien factories",
    },
  },
  news_flow: {
    back_to_list: "Back to list",
    no_results: "Article not found",
    editorial_board: "Editorial Board",
    share: "Share",
    related_news: "Related News",
    promo_title: "Ora Park App",
    promo_desc: "Download the Ora Park app to update the latest price list and sales policies.",
    promo_btn: "Download App Now",
    blog_title: "News & Events",
    blog_desc: "Stay updated with the latest news, events, and project progress",
    read_more: "Read more",
    categories: {
      company: "Dragon Home News",
    },
  },
};

export default en;
